import React, { useEffect, useState, useContext } from "react";
import { SubjectDataContext } from "./SubjectRoot";
import { FiEdit2, FiAlertTriangle } from "react-icons/fi";
import { SubjectDemographicsTable } from "../components/Tables/SubjectDemographicsTable";
import { AccountSettingsTable } from "../components/Tables/AccountSettingsTable";
import patient_account_types from "../config/patient_account_types";
import account_status from "../config/account_status";
import Global from "../utils/Global";
import { useNavigate } from "react-router-dom";

export default function PatientDetails() {
  // Get common data from context
  const { subject, display_type, setRefreshData } = useContext(SubjectDataContext);
  
  // Local state for this component
  const [isTabLoading, setIsTabLoading] = useState(false);
  const [sentConfirmationCode, setSentConfirmationCode] = useState(false);
  const [successfullySentConfirmationCode, setSuccessfullySentConfirmationCode] = useState(null);
  
  let navigate = useNavigate();

  const handleResendConfirmationCode = () => {
    if (sentConfirmationCode) {
      return;
    }
    setSentConfirmationCode(true);
    Global.localAppHandler
      .app_resend_confirmation_code()
      .then((returnStatus) => {
        setSuccessfullySentConfirmationCode(true);
      })
      .catch((err) => {
        setSuccessfullySentConfirmationCode(false);
        console.log(err);
      });
  };

  return (
    <div className="container-xl px-4">
      {subject?.account_type === patient_account_types.remote && subject?.account_status === account_status.pending ? (
        <div className="alert alert-primary mt-4">
          {sentConfirmationCode ? (
            successfullySentConfirmationCode === null ? (
              "Sending..."
            ) : successfullySentConfirmationCode ? (
              "Confirmation code resent!"
            ) : (
              "Error sending confirmation code. Refresh page and try again."
            )
          ) : (
            <>
              <FiAlertTriangle className="mb-1" style={{ marginRight: "10px" }} />
              {"Patient has not yet redeemed account. Pending for " + subject?.days_pending + " days. Make sure contact phone is correct."}
              <span
                className="link-primary"
                onClick={handleResendConfirmationCode}
                style={{ textDecoration: "underline", marginLeft: "5px", cursor: "pointer" }}
              >
                Resend Confirmation Code
              </span>
            </>
          )}
        </div>
      ) : (
        <></>
      )}

      <div className="card mb-4">
        <div className="card-header" style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="d-flex align-items-center justify-content-between">Patient Profile</div>
          <button
            onClick={() => {
              const newPath = window.location.pathname.slice(0, window.location.pathname.lastIndexOf("/")) + "/edit";
              navigate(newPath);
            }}
            disabled={subject ? false : true}
            className={`btn btn-primary ${subject ? "" : "btn-disabled"}`}
          >
            Edit <FiEdit2 className="mb-1" style={{ marginLeft: "10px" }} />
          </button>
        </div>
        <div className="card-body">
          <SubjectDemographicsTable subject={subject} displayType={display_type} />
        </div>
      </div>

      <AccountSettingsTable subject={subject} isLoading={isTabLoading} displayType={display_type} setRefreshData={setRefreshData} />
    </div>
  );
}